import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import {
  FETCH_WATCH_AND_WIN_CONFIG_QUERY,
  FETCH_WATCH_AND_WIN_LEADERBOARD_QUERY,
  FETCH_WATCH_AND_WIN_PLAYER_STAT_IN_CAMPAIGN_QUERY
} from '../GraphQL/Queries/WatchAndWinQuery';
import { graphQlRequest } from '../GraphQL/RequestHandler';
import { HTTP_HEADER_KEYS } from 'src/utils/constants/HttpMethodsConstants';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { USER_TYPE } from 'src/utils/constants/localStorageConstants';

export const fetchWatchAndWinConfig = async (gameMappedId: string) => {
  const requestParams = {
    mapperId: gameMappedId
  };

  try {
    const response = await graphQlRequest(
      FETCH_WATCH_AND_WIN_CONFIG_QUERY,
      requestParams,
      GQL_QUERIES.FETCH_WATCH_AND_WIN_CONFIG_QUERY
    );
    return response?.watchAndWinConfig || {};
  } catch (error) {
    console.error('Error while fetching watch and win config query: ', error);
    return null;
  }
};

export const fetchWatchAndWinLeaderboard = async (
  date: string,
  type: string,
  gameMappedId: string
) => {
  const requestParams = {
    date,
    type,
    mapperId: gameMappedId
  };

  try {
    const response = await graphQlRequest(
      FETCH_WATCH_AND_WIN_LEADERBOARD_QUERY,
      requestParams,
      GQL_QUERIES.FETCH_WATCH_AND_WIN_LEADERBOARD_QUERY
    );
    return response?.watchAndWinLeaderBoard || {};
  } catch (error) {
    console.error(
      'Error while fetching watch and win leaderboard query: ',
      error
    );
    return null;
  }
};

export const fetchWatchAndWinPlayerStatInCampaign = async (
  gameMappedId: string
) => {
  const requestParams = {
    mapperId: gameMappedId
  };

  const requestHeaders: string[] = [HTTP_HEADER_KEYS.X_ACCESS_TOKEN];
  if (getLocalStorage(USER_TYPE) === 'guest') {
    requestHeaders.push(HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN);
  } else {
    requestHeaders.push(HTTP_HEADER_KEYS.AUTHORIZATION);
  }

  try {
    const response = await graphQlRequest(
      FETCH_WATCH_AND_WIN_PLAYER_STAT_IN_CAMPAIGN_QUERY,
      requestParams,
      GQL_QUERIES.FETCH_WATCH_AND_WIN_PLAYER_STAT_IN_CAMPAIGN_QUERY,
      requestHeaders
    );
    return response?.playerStatsInCampaign || {};
  } catch (error) {
    console.error(
      'Error while fetching watch and win player stats in campaign query: ',
      error
    );
    return null;
  }
};
